var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DefaultError',[_c('h1',{staticClass:"text-grey color-60 pd-t-5"},[_vm._v(" ขออภัย ไม่พบหน้าดังกล่าว"),_c('br'),_c('span',{staticClass:"text-white not-hover cursor-pointer font-20 text-primary",on:{"click":_vm.signOut}},[_c('u',[_vm._v("กลับสู่หน้าหลัก")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }